<div class="cm-login-container">
    @if ($isVerifying()) {
        <cm-full-page-feedback class="cm-full-page-feedback" [icon]="$provider() ?? 'google'" text="Verifying SSO sign-up..."></cm-full-page-feedback>
    } @else if ($error()) {
        <div class="cm-login-card">
            <div class="cm-login-card-header">Sign Up Failed</div>
            <div class="cm-login-form">
                <div class="cm-error-message">
                    <i class="far fa-exclamation-circle"></i>
                    {{ $error() }}
                </div>
                <button class="cm-sign-in-button cm-active" type="button" (click)="navigateToSignUp()">
                    <i class="far fa-arrow-left"></i>
                    Try Again
                </button>
                <a class="cm-reset-password" (click)="navigateToLogin()">Already have an account? Log in.</a>
            </div>
        </div>
    }
</div>
